export const enum AutocompleteAmplitudeEvent {
  DictionaryAutocompleteAccepted = 'Dictionary autocomplete accepted',
  DictionaryAutocompleteSwitched = 'Dictionary autocomplete switched',
  AIAutocompleteCannedDisplayed = 'AI autocomplete canned displayed',
  AIAutocompleteCannedAccepted = 'AI autocomplete canned accepted',
  AIAutocompleteCannedSwitched = 'AI autocomplete canned switched',
  AIAutocompleteCannedSent = 'AI autocomplete canned sent',
}
